/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */
const PHOTO_SELECTION_SCREEN_PREFIX = 'PhotoSelectionScreen-';
const PHOTO_PREVIEW_ITEM_PREFIX = 'PhotoPreviewItem-';
const SPINNER_PREFIX = 'Spinner-';

export const TEST_IDS = {
  PhotoSelectionScreen: {
    SubmitButton: `${PHOTO_SELECTION_SCREEN_PREFIX}SubmitButton`,
  },
  PhotoPreviewItem: {
    UnsupportedFiletypeIcon: `${PHOTO_PREVIEW_ITEM_PREFIX}UnsupportedFiletypeIcon`,
    PlaceholderIcon: `${PHOTO_PREVIEW_ITEM_PREFIX}PlaceholderIcon`,
  },
  Spinner: {
    Container: `${SPINNER_PREFIX}Container`,
  },
} as const;
